"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ProductWithSellerFragment = (0, graphql_tag_1.default)(`
  fragment seller on Seller {
    id
    sku
    description
    category
    deliveryId
    deliveryDescription
    restrictions
    details {
      id
      legalName
      documentNumber
      shippingDocumentNumber
      score
      sellerSince
      totalSales
      deliveryRate {
        message
        status
      }
      answerRate {
        message
        status
      }
      address {
        address
        number
        complement
        district
        city
        state
        country
        zipcode
      }
      regulatoryData {
        mapa {
          notApply
          items
        }
        anvisa {
          notApply
          items
        }
      }
    }
     tags {
      code
      discountType
      discountValue
      endDate
      message
      type
      version
      action {
        type
        url
      }
    }
    isChatEnabled
  }
`);
exports.default = ProductWithSellerFragment;
